// src/pages/.../MitraSetup.jsx
import React, { useState, useEffect } from "react";
import SectionKelola from "../../../components/CrudUserSetup/SectionKelola";
import SectionKelolaDuaField from "components/CrudUserSetup/SectionKelolaDuaField";
import ConfirmDialog from "../../../components/Feedback/ConfirmDialog";
import AlertDialog from "../../../components/Feedback/AlertDialog";

import {
  getAllPartnerTypes,
  createPartnerType,
  deletePartnerType,
  updatePartnerType,
} from "../../../services/partnerTypeService";

import {
  getAllRoles,
  createRole,
  updateRole,
  deleteRole,
} from "../../../services/roleService";
import {
  getAllMemberStatus,
  createMemberStatus,
  updateMemberStatus,
  deleteMemberStatus,
} from "../../../services/memberStatusService";

const MitraSetup = () => {
  const [partnerTypes, setPartnerTypes] = useState([]); // jenis mitra (API)
  const [roles, setRoles] = useState([]); // role mitra (API, status PARTNER)
  const [statuses, setStatuses] = useState([]);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [deleteType, setDeleteType] = useState("");
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  // helper: normalisasi respons dari service
  const normalizeArray = (res) => {
    if (!res) return [];
    if (Array.isArray(res)) return res;
    if (Array.isArray(res.data)) return res.data;
    if (Array.isArray(res.data?.data)) return res.data.data;
    return [];
  };

  useEffect(() => {
    const fetchAll = async () => {
      try {
        // partner types
        const ptRes = await getAllPartnerTypes();
        const pts = normalizeArray(ptRes);
        setPartnerTypes(pts);

        // roles, lalu filter status PARTNER
        const rRes = await getAllRoles();
        const rs = normalizeArray(rRes);
        const partnerRoles = rs.filter(
          (r) => (r.status || "").toString().toUpperCase() === "PARTNER"
        );
        setRoles(partnerRoles);

        // status mitra
        const sRes = await getAllMemberStatus();
        const ss = normalizeArray(sRes);
        const partnerStatuses = ss.filter(
          (s) => (s.status || "").toString().toUpperCase() === "PARTNER"
        );
        setStatuses(partnerStatuses);
      } catch (err) {
        console.error("Gagal memuat data Mitra:", err);
      }
    };

    fetchAll();
  }, []);

  // === PartnerType CRUD (API) ===
  const handleAddPartnerType = async (value) => {
    try {
      const res = await createPartnerType({
        name: value.name,
        code: value.code,
      });
      const newItem = normalizeArray(res)[0] ?? res?.data ?? res;
      setPartnerTypes((prev) => [newItem, ...prev]);
      setAlertMessage("Jenis Mitra berhasil ditambahkan!");
      setIsAlertOpen(true);
    } catch (err) {
      console.error(
        "Gagal menambah jenis mitra:",
        err?.response?.data ?? err.message ?? err
      );
    }
  };

  const handleEditPartnerType = async (item) => {
    try {
      const res = await updatePartnerType(item.id, {
        name: item.name,
        code: item.code,
      });
      const updated = normalizeArray(res)[0] ?? res?.data ?? res;
      setPartnerTypes((prev) =>
        prev.map((p) => (p.id === updated.id ? updated : p))
      );
    } catch (err) {
      console.error(
        "Gagal mengedit jenis mitra:",
        err?.response?.data ?? err.message ?? err
      );
    }
  };

  // const handleDeletePartnerType = async (item) => {
  //   try {
  //     await deletePartnerType(item.id);
  //     setPartnerTypes((prev) => prev.filter((p) => p.id !== item.id));
  //   } catch (err) {
  //     console.error(
  //       "Gagal menghapus jenis mitra:",
  //       err?.response?.data ?? err.message ?? err
  //     );
  //   }
  // };

  // === Role Mitra CRUD (API) - selalu kirim status: "PARTNER" ===
  const handleAddRole = async (name) => {
    try {
      const res = await createRole({ name, status: "PARTNER" });
      const newItem = res.data?.data || res.data;

      // Pastikan status PARTNER
      newItem.status = "PARTNER";

      setRoles((prev) => [newItem, ...prev]);
      setAlertMessage("Status Mitra berhasil ditambahkan!");
      setIsAlertOpen(true);
    } catch (err) {
      console.error(
        "Gagal menambah role mitra:",
        err?.response?.data ?? err.message ?? err
      );
    }
  };

  const handleEditRole = async (item) => {
    const name = item?.name ?? item?.label ?? "";
    try {
      const res = await updateRole(item.id, { name, status: "PARTNER" });
      const updated = normalizeArray(res)[0] ?? res?.data ?? res;
      setRoles((prev) => prev.map((r) => (r.id === updated.id ? updated : r)));
    } catch (err) {
      console.error(
        "Gagal mengedit role mitra:",
        err?.response?.data ?? err.message ?? err
      );
    }
  };

  // const handleDeleteRole = async (item) => {
  //   try {
  //     await deleteRole(item.id);
  //     setRoles((prev) => prev.filter((r) => r.id !== item.id));
  //   } catch (err) {
  //     console.error(
  //       "Gagal menghapus role mitra:",
  //       err?.response?.data ?? err.message ?? err
  //     );
  //   }
  // };

  // === Status Mitra CRUD (API) - selalu kirim status: "PARTNER" ===
  const handleAddStatus = async (name) => {
    try {
      const res = await createMemberStatus({ name, status: "PARTNER" });
      const newItem = res.data?.data || res.data;
      newItem.status = "PARTNER";
      setStatuses((prev) => [newItem, ...prev]);
      setAlertMessage("Role Mitra berhasil ditambahkan!");
      setIsAlertOpen(true);
    } catch (err) {
      console.error(
        "Gagal menambah status mitra:",
        err?.response?.data ?? err.message ?? err
      );
    }
  };

  const handleEditStatus = async (item) => {
    try {
      const res = await updateMemberStatus(item.id, {
        name: item.name,
        status: "PARTNER",
      });
      const updated = normalizeArray(res)[0] ?? res?.data ?? res;
      setStatuses((prev) =>
        prev.map((s) => (s.id === updated.id ? updated : s))
      );
    } catch (err) {
      console.error(
        "Gagal mengedit status mitra:",
        err?.response?.data ?? err.message ?? err
      );
    }
  };

  // const handleDeleteStatus = async (item) => {
  //   try {
  //     await deleteMemberStatus(item.id);
  //     setStatuses((prev) => prev.filter((s) => s.id !== item.id));
  //   } catch (err) {
  //     console.error(
  //       "Gagal menghapus status mitra:",
  //       err?.response?.data ?? err.message ?? err
  //     );
  //   }
  // };

  const handleConfirmDelete = async () => {
    if (!selectedDeleteItem) return;

    try {
      if (deleteType === "partnerType") {
        await deletePartnerType(selectedDeleteItem.id);
        setPartnerTypes((prev) =>
          prev.filter((p) => p.id !== selectedDeleteItem.id)
        );
      } else if (deleteType === "status") {
        await deleteMemberStatus(selectedDeleteItem.id);
        setStatuses((prev) =>
          prev.filter((s) => s.id !== selectedDeleteItem.id)
        );
      } else if (deleteType === "role") {
        await deleteRole(selectedDeleteItem.id);
        setRoles((prev) => prev.filter((r) => r.id !== selectedDeleteItem.id));
      }
    } catch (err) {
      console.error("Gagal menghapus:", err?.response?.data ?? err.message);
    } finally {
      setIsConfirmOpen(false);
      setSelectedDeleteItem(null);
      setDeleteType("");
    }
  };

  return (
    <div className="pt-10 pb-10 pl-64 pr-6">
      <h1 className="mb-6 text-2xl font-bold text-green-800">
        Manajemen Mitra
      </h1>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        {/* Jenis Mitra (API) */}
        <SectionKelolaDuaField
          title="Jenis Mitra"
          data={partnerTypes}
          onAdd={handleAddPartnerType}
          onDelete={(item) => {
            setSelectedDeleteItem(item);
            setDeleteType("partnerType");
            setIsConfirmOpen(true);
          }}
          onEdit={handleEditPartnerType}
        />

        <SectionKelola
          title="Status Mitra"
          data={statuses}
          onAdd={handleAddStatus}
          onDelete={(item) => {
            setSelectedDeleteItem(item);
            setDeleteType("status");
            setIsConfirmOpen(true);
          }}
          onEdit={handleEditStatus}
        />

        {/* Role Mitra via API (status PARTNER) */}
        <SectionKelola
          title="Role Mitra"
          data={roles}
          onAdd={handleAddRole}
          onDelete={(item) => {
            setSelectedDeleteItem(item);
            setDeleteType("role");
            setIsConfirmOpen(true);
          }}
          onEdit={handleEditRole}
        />
      </div>
      <ConfirmDialog
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirmDelete}
        title="Hapus Data"
        message="Apakah Anda yakin ingin menghapus data ini?"
      />
      {isAlertOpen && (
        <AlertDialog
          isOpen={isAlertOpen}
          onClose={() => setIsAlertOpen(false)}
          title="Berhasil"
          message={alertMessage}
        />
      )}
    </div>
  );
};

export default MitraSetup;
